import { Component, AfterContentInit, OnDestroy, ViewChild, OnInit, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { AwardDTO, ProcurementProjectDTO } from '../../api/plyca-dtos-v2';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, switchMap, take, tap } from 'rxjs/operators';
import { UIService } from '../../ui.service';
import { PropertyService } from '../../properties/property.service';
import { deNormalizaDossierId, I18nData, MasterDataDTO } from '../../api/plyca-dtos';
import { Configuration } from '../../conf/app.constants';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { MenuItem } from 'primeng-lts/api';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';


// tslint:disable-next-line: component-class-suffix// Bean de la pantalla.
export class FrameworkAgreementAttrResult {
  CONTRATOID: string;
  ADJUDICATARIO: string;
  FECHA_ADJ: string;
}

// Bean de la pantalla.
export class FrameworkAgreementModelDTO {
  dossierId: string;
  frameworkAgreement: ProcurementProjectDTO; // Acuerdo marco
  year: string; // Años desde la creacion del Acuerdo Marco
  state: MasterDataDTO; // Estado del contrato basado
  award: AwardDTO // Adjudicatario Seleccionado.
  yearsList: any[];
  filterFrameWorkAgreementContractList: any[] = []; // Adjudicaciones del Acuerdo Marco
  filterBasedContractList: any[] = []; // Lista de Basados
  totalBasedContract = 0; // Totalizaciones para mostrar en cliente
  totalAwards = 0; // Totalizaciones para mostrar en cliente
  totalFilterAwardBasedContract = 0;  // Totalizaciones para mostrar en cliente
  isModeEdition: boolean;
  basedContractAccumulatedExpense: number;
}

@Component({
  selector: 'frameworkAgreementSituationAYMAD',
  templateUrl: 'frameworkAgreementSituationAYMAD.template.html',
  providers: [DialogService]
})



export class FrameworkAgreementSituationAYMADComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;
  // public filterModel: any;
  loaded = true;

  visibleItems = true;

  basedContract: ProcurementProjectDTO; // Contrato Basado. Si se abre desde un CBAM, tiene que mostar su AM. La cabecera, debe ser del CBAM

  // Lista Auxiliar
  frameWorkAgreementContractList: any[] = []; // Adjudicaciones del Acuerdo Marco
  basedContractList: any[] = []; // Lista de Basados
  stateProperty: string;
  phaseProperty: string;
  newBasedContractEnabled: boolean;

  // Propiedades
  propertyEstadosCB: any;
  propertyEstadosCBAdjudicados: any;

  // Varibles para los parametros de consulta de los atributos
  paramsAttributeDossierId: string;

  // Modelo de la pantalla
  model: FrameworkAgreementModelDTO;
  frameworkAgreementIdentifier: string;
  new = false;
  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  // userPrefs: UserPrefs;

  constructor(
    public plycaService: PlycaDataService,
    private router: Router,
    private elem: ElementRef,
    private uiService: UIService,
    private propertyService: PropertyService,
    public configuration: Configuration,
    /*public configuration: Configuration,
    public helpService: HelpService,
    public uiService: UIService,
    public userService: UserService,*/
    public dialogService: DialogService,
    // public translate: TranslateService*/
    public waitService: WaitLoadingService,
    public headerActionsService: HeaderActionsService,
    public activatedRoute: ActivatedRoute,
    public plycaErrorHandler: PlycaErrorHandler,
    private translateService: TranslateService,
    private location: Location,
  ) {
    super();
    this.subscribe(this.activatedRoute.params, params => {
      this.frameworkAgreementIdentifier = params['id'];
      if (params['mode'] !== undefined) {
        this.new = true;
      }
      this.paramsAttributeDossierId = 'PROPUESTAID=' + this.frameworkAgreementIdentifier;
      this.subscribe(
        forkJoin([
          this.propertyService.getProperty('ESTADOS_CB_ADJUDICADOS', '')
            .pipe(catchError((error: any) => {
              console.log(error)
              return of(undefined)
            })),
          this.propertyService.getProperty('FASES_TRAMITACION_CB', '')
            .pipe(catchError((error: any) => {
              console.log(error)
              return of(undefined)
            }))
        ]),
        ([resultPropertyEstados, resultPropertyFases]) => {
          if (resultPropertyEstados) {
            this.stateProperty = resultPropertyEstados;
          }
          if (resultPropertyFases) {
            this.phaseProperty = resultPropertyFases;
          }
        },
        error => {
          this.plycaErrorHandler.showServerError(error)
        });
      this.setModel();
    })
  }

  initHeaderInfo() {
    if (!this.model.isModeEdition) {
      this.headerActionsService.setTaskDescription(
        this.elem,
        'Situación de Acuerdos Marco y sus Contratos Basados',
        'fa-file-contract',
        this.isLoaded.bind(this)
      );
      let project: ProcurementProjectDTO;
      if (this.basedContract) {
        project = this.basedContract;
      } else {
        project = this.model.frameworkAgreement;
      }
      this.headerActionsService.setProject(this.elem, project, false);
    } else {
      this.headerActionsService.setTaskDescription(
        this.elem, 'Situación de Acuerdos Marco y sus Contratos Basados', 'fa-file-contract', this.isLoaded.bind(this));
    }
  }

  ngOnInit(): void {
  }

  loadFunctions(_formConfig: FormConfig) {

    _formConfig.functions.push({
      identifier: 'getTextAward',
      fn: this.getTextAward.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'setValueParamsAttr_am',
      fn: this.setValueParamsAttr_am.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'filterLists',
      fn: this.filterLists.bind(this)
    });

    /*_formConfig.functions.push({
      identifier: 'getDossierMenuItem',
      fn: this.getDossierMenuItem.bind(this)
    });*/
  }


  setModel() {
    this.model = new FrameworkAgreementModelDTO();
    this.model.frameworkAgreement = new ProcurementProjectDTO();
    // No tenemos identificador. Hay que seleccionar el AM.
    if (this.frameworkAgreementIdentifier === undefined) {
      this.newBasedContractEnabled = true;
      this.subscribe(this.createFormConfig1(),
        (form1: FormConfig) => {
          this.model.isModeEdition = true;
          this.loadFunctions(form1);
          this.formConfig1 = form1;
        })
    } else {
      // Tenemos identificador. Se precarga el AM
      if (this.new) {
        this.newBasedContractEnabled = true;
        this.model.isModeEdition = true;
      } else {
        this.newBasedContractEnabled = false;
        this.model.isModeEdition = false;
      }
      this.waitService.startWaiting();
      let expansionDossier = '?expand=expansionSet:subclass_complete';
      this.subscribe(
        this.plycaService.getProcurementProject(
          this.frameworkAgreementIdentifier, expansionDossier
        ).pipe(
          switchMap(
            result => {
              let isCBAM = (result?.classification?.complementarySystem?.identifier === 'CBAM<>SISTCOMPLEMENTARIO');
              if (isCBAM) {
                this.basedContract = result;
                let originalContractingSystemID = deNormalizaDossierId(result?.contractingSystem?.originalContractingSystemID?.identifier);
                return this.plycaService.getProcurementProject(originalContractingSystemID, expansionDossier);
              } else {
                return of(result);
              }
            }
          ),
          tap(result => {
            this.model = new FrameworkAgreementModelDTO();
            this.model.frameworkAgreement = result;
            /*if (this.newBasedContractEnabled = true) {
              this.model.isModeEdition = true;
            }*/
            this.paramsAttributeDossierId = 'PROPUESTAID=' + result.identifier;
            /*this.model.dossierId = this.model.frameworkAgreement.identifier.substring(0, 4) + '/' +
              this.model.frameworkAgreement.identifier.substring(4);*/
            this.model.dossierId = this.model.frameworkAgreement.identifier;
          }
          ),
          catchError(
            (err: any) => {
              this.plycaErrorHandler.showServerError(err);
              return throwError(err);
            }
          ),
          finalize(() => {
            // console.log(this.stateProperty);
            this.initHeaderInfo();
            // this.getAccumulatedExpense();

            /*this.subscribe(this.createFormConfig1(),
              (form1: FormConfig) => {
                this.loadFunctions(form1);
                this.formConfig1 = form1;
                this.searchAll();
              });*/


            this.subscribe(this.createFormConfig1().pipe(
              tap((form1: FormConfig) => {
                this.loadFunctions(form1);
                this.formConfig1 = form1;
                this.searchAll();
                this.waitService.cancelWaiting();
              })
            )
            );
          })
        ))
    }
  }


  private createFormConfig1(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'frameworkAgreementSituation/frameworkAgreementSituation.json',
      this.model
    ));

  }

  ngAfterContentInit(): void {
    this.loaded = true;
    this.initHeaderInfo();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });
  }

  ngOnDestroy() {

    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  private activeContract(row: any) {
    let today = new Date();
    let todayCompare = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    let contractDate = row.columns['FECHA_VIGENCIA']?.value;
    let compare = contractDate !== undefined && contractDate !== '';
    let valid = true;
    if (compare) {
      let parts = contractDate.split('-');
      let day = Number(parts[0]);
      let month = Number(parts[1]);
      let year = Number(parts[2]);
      let activeDate = new Date(year, month - 1, day, 0, 0, 0);
      if (todayCompare.getTime() > activeDate.getTime()) {
        valid = false;
      }
    }
    return valid;
  }

  private validContract(row: any) {
    let contract = row.columns['FECHA_VIGENCIA']?.value;
    let valid = contract !== undefined && contract !== '';
    return valid;
  }

  private existsPreviosBasedContract(row: any) {
    let exist = false;
    let award = row.columns['ADJUDICATARIO']?.value;
    let sepPos = award.indexOf('-');
    let frameWorkAgreementAwardIdentifier = award.substring(sepPos + 1);
    // sepPos = awardTaxIdentifierAux.indexOf('-');
    // let frameWorkAgreementAwardIdentifier = awardTaxIdentifierAux.substring(0, sepPos);
    if (this.basedContractList !== undefined) {
      let filterBasedContractList = this.basedContractList
        .filter(basedContract => basedContract?.columns['EMPRESADNICIF_AM']?.value === frameWorkAgreementAwardIdentifier);
      if (filterBasedContractList !== undefined && filterBasedContractList.length > 0) {
        let filterAwardContractList = filterBasedContractList;
        // filtramos por la columna FASE_CBAM
        let phases = this.phaseProperty.split(';');
        phases.forEach(phase => {
          filterBasedContractList = filterAwardContractList
            .filter(basedContract => basedContract?.columns['FASE_CBAM']?.value === phase);
          if (!exist) {
            exist = filterBasedContractList !== undefined && filterBasedContractList.length > 0;
          }
        });
      }
    }
    return exist;
  }

  private openNewBasedContract(row: any) {
    let contractDivisionFrameworkAgreement = row.columns['DIVISION_CONTRATO']?.value;
    this.router.navigate(['/dossierInfo/' + this.frameworkAgreementIdentifier]);
    /*this.router.navigate(['procurementProjectAYMAD/', 'new'], {
      queryParams: {
        frameworkAgreementIdentifier: this.frameworkAgreementIdentifier
      }
    });*/
    // this.router.navigate(['/procurementProjectAYMAD/'], { queryParams: { component: 'CONTRACTS', } });
    let ruta = 'procurementProjectAYMAD/';
    let setDefinitionIdentifier = 'FE_CBAM_AYMAD';
    this.router.navigate([ruta],
      {
        queryParams: {
          formid: setDefinitionIdentifier, isModel: 'false', isBasedContract: 'true',
          frameworkAgreementParent: this.frameworkAgreementIdentifier,
          contractDivisionFrameworkAgreement: contractDivisionFrameworkAgreement
        }
      });
  }

  public createBasedContract(row: any): void {
    let createBasedContract = true;
    let existPreviosBasedContract = this.existsPreviosBasedContract(row);
    let validContract = this.validContract(row);
    let activeContract = this.activeContract(row);
    if (!validContract) {
      this.uiService.showMessage(new I18nData('FrameworkAgreementSituation.invalidContract'),
        'Aviso'
      );
    } else if (!activeContract) {
      this.uiService.showMessage('No se pueden inicar contratos basados sobre esta Adjudicación de Acuerdo Marco, puesto que no está vigente.',
        'Aviso');
    } else if (existPreviosBasedContract) {
      this.uiService.showConfirmMessage({
        message: 'Existen Contratos Basados para esta adjudicación de Acuerdo Marco que no están aún adjudicados. ¿Desea continuar?',
        header: 'Aviso',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.openNewBasedContract(row);
        },
        reject: () => {
          createBasedContract = false;
        }
      });
    } else {
      this.openNewBasedContract(row);
    }
  }

  searchAll() {
    this.subscribe(
      forkJoin([
        this.plycaService.getAttributeValue(
          'SITUACION_ADJUDICACIONES_AM',
          this.paramsAttributeDossierId
        ).pipe(catchError((error: any) => {
          return of(undefined)
        })),
        this.plycaService.getAttributeValue(
          'SITUACION_LISTA_CBAM',
          this.paramsAttributeDossierId
        ).pipe(catchError((error: any) => {
          return of(undefined)
        }))
      ]),
      ([resultAM, resultCBAM]) => {
        if (resultAM) {
          // comprobar si hay lotes
          if (resultAM && resultAM.values && resultAM.values.length > 0) {
            /*this.model.dossierId = this.model?.frameworkAgreement?.identifier.substring(0, 4) + '/' +
              this.model?.frameworkAgreement?.identifier.substring(4);*/
            this.model.dossierId = this.model.frameworkAgreement.identifier;
            this.model.filterFrameWorkAgreementContractList = resultAM.values;
            this.model.filterBasedContractList = [];
          } else {
            this.model.filterFrameWorkAgreementContractList = [];
            this.model.filterBasedContractList = [];
          }
          this.frameWorkAgreementContractList = this.model.filterFrameWorkAgreementContractList;
          if (this.model.filterFrameWorkAgreementContractList.length > 0) {
            this.model.filterFrameWorkAgreementContractList.forEach(element => {
              element.newBasedContractEnabled = this.newBasedContractEnabled;
            });
          }
          this.setYears();
          this.loaded = true;
          setTimeout(() => {
            this.visibleItems = true;

          }, 250);
        }
        if (resultCBAM) {
          // comprobar si hay lotes

          /*if (resultCBAM && resultCBAM.values && resultCBAM.values.length > 0) {
            const observables = resultCBAM.values.map(values => {
              let basedContractDossierId = values.columns['PROPUESTA_CBAM']?.value;
              basedContractDossierId = deNormalizaDossierId(basedContractDossierId);
              return this.plycaService.getProcurementProject(basedContractDossierId, '?expand=expansionSet:minimal').pipe(
                catchError(error => {
                  console.error('Error obteniendo proyecto de contratación:', error);
                  // Devuelve EMPTY para continuar con el flujo
                  return EMPTY;
                }),
                tap((basedContract: ProcurementProjectDTO) => {
                  if (basedContract) {
                    values.columns['PROPUESTA_CBAM'].value = basedContract;
                  } else {
                    console.log('Sin respuesta');
                  }
                })
              );
            });

            forkJoin(observables).subscribe(() => {
              console.log(' - Todo el procesamiento después de que se completen todas las solicitudes.');
              // Aquí puedes colocar el código que debe ejecutarse después de que todas las asignaciones se completen
            });
          }*/

          if (resultCBAM && resultCBAM.values && resultCBAM.values.length > 0) {
            this.model.filterBasedContractList = resultCBAM.values;
          } else {
            this.model.filterBasedContractList = []
          }
          this.basedContractList = this.model.filterBasedContractList;
          this.model.totalBasedContract = this.basedContractList.length;
          this.model.totalFilterAwardBasedContract = 0;
          this.model.totalAwards = this.frameWorkAgreementContractList.length;
          this.loaded = true;
          this.filterLists();
        }
      },
      error => {
        this.plycaErrorHandler.showServerError(error)
      });
  }

  public setYears() {
    this.model.yearsList = [];
    if (this.model.frameworkAgreement) {
      let startYear = this.model.frameworkAgreement.startYear;
      let today = new Date();
      let actualYear = today.getFullYear();
      while (startYear <= actualYear) {
        this.model.yearsList.push({ label: startYear + '', value: startYear + '' });
        startYear++;
      }
    }
  }

  public setValueParamsAttr_am(model: any) {
    this.visibleItems = false;
    this.model.award = undefined;
    this.model.year = undefined;
    this.model.state = undefined;
    this.model.filterFrameWorkAgreementContractList = [];
    this.model.filterBasedContractList = [];
    if (model && model.frameworkAgreement && model.frameworkAgreement.identifier) {
      this.frameworkAgreementIdentifier = model.frameworkAgreement.identifier;
      this.paramsAttributeDossierId = 'PROPUESTAID=' + this.frameworkAgreementIdentifier;
      this.searchAll();
    } else {
      this.paramsAttributeDossierId = '';
    }
    let identifier = deNormalizaDossierId(this.frameworkAgreementIdentifier);
    let url = "frameworkAgreementSituationAYMAD/" + identifier + "/reload";
    this.location.replaceState(url);
  }


  public filterLists() {
    // Si no hay filtros, mostramos la lista completa.
    if (!this.model.award && !this.model.year && !this.model.state) {
      this.model.filterFrameWorkAgreementContractList = this.frameWorkAgreementContractList;
      this.model.filterBasedContractList = this.basedContractList;
      // calculamos el gasto acumulado de los que muestra por defecto.
      let auxStates = this.stateProperty.split(';');
      let basedContractAccumulatedExpenseList = this.model.filterBasedContractList.filter(basedContract => {
        let stateId = basedContract?.columns['TIPOESTADOID']?.value;
        let stateExists = false;

        auxStates.forEach(auxState => {
          if (stateId !== undefined && auxState === stateId.toString()) {
            stateExists = true;
          }
        });

        return stateExists;
      });

      let total = 0.0;
      basedContractAccumulatedExpenseList.forEach(basedContract => {
        if (basedContract?.columns['PRECIO']?.value) {
          total += this.roundDecimals(Number(basedContract?.columns['PRECIO'].value));
        }
      })
      this.model.basedContractAccumulatedExpense = total;

    } else {
      let auxFrameworkAgreementContractList = this.frameWorkAgreementContractList;
      let auxBasedContractList = [...this.basedContractList];

      // 1. Adjudicatario: Filtramos las dos listas
      if (this.model.award) {
        // PLA.AYMAD-3217 --> Filtra por DNICIF en vez de por division de contrato.


        const awardTaxIdentifier = this.model?.award?.company?.taxIdentifier;

        auxFrameworkAgreementContractList = auxFrameworkAgreementContractList
          .filter(amContract => amContract?.columns['EMPRESADNICIF']?.value === awardTaxIdentifier);

        auxBasedContractList = auxBasedContractList.filter(basedContract =>
          basedContract?.columns['EMPRESADNICIF_ADJ_CBAM']?.value === awardTaxIdentifier ||
          basedContract?.columns['EMPRESADNICIF_ADJ_CBAM']?.value === undefined ||
          basedContract?.columns['EMPRESADNICIF_ADJ_CBAM']?.value === ''
        );

        this.model.totalFilterAwardBasedContract = auxBasedContractList.length;

      } else {
        this.model.totalFilterAwardBasedContract = 0;
      }

      // 2. Año. Filtramos solo los basados
      if (this.model?.year) {

        const filterYear = this.model?.year;
        auxBasedContractList = auxBasedContractList.filter(basedContract => {
          const basedContractYear = basedContract?.columns['ANOINICIO']?.value;
          if (basedContractYear === filterYear) {
            return true;
          } else {
            const awardDate = basedContract?.columns['FECHA_ADJ']?.value;
            const yearAwardDate = awardDate?.substring(awardDate.length - 4); // Extrae el año del formato dd-mm-yyyy
            return yearAwardDate === filterYear;
          }
        });




      }



      let auxStates = this.stateProperty.split(';');

      let basedContractAccumulatedExpenseList = auxBasedContractList.filter(basedContract => {
        let stateId = basedContract?.columns['TIPOESTADOID']?.value;

        let stateExists = false;

        auxStates.forEach(auxState => {
          if (stateId !== undefined && auxState === stateId.toString()) {
            stateExists = true;
          }
        });

        return stateExists;
      });

      let total = 0.0;
      basedContractAccumulatedExpenseList.forEach(basedContract => {
        if (basedContract?.columns['PRECIO']?.value) {
          total += this.roundDecimals(Number(basedContract?.columns['PRECIO'].value));
        }
      })
      this.model.basedContractAccumulatedExpense = total;
      // 3. Filtramos por los valores de la propiedad ESTADOS_CB_ADJUDICADOS. Primer filtro por la lógica complicada.

      if (this.model?.state && this.model?.state?.identifier) {
        const filterState = this.model.state.identifier.substring(0, this.model.state.identifier.indexOf('<>'));
        if (filterState === '72') {
          const auxStates = this.stateProperty.split(';');
          auxBasedContractList = auxBasedContractList.filter(basedContract =>
            auxStates.includes(basedContract?.columns['TIPOESTADOID']?.value)
          );
        } else {
          auxBasedContractList = auxBasedContractList.filter(basedContract =>
            basedContract?.columns['TIPOESTADOID']?.value === filterState
          );
        }
      }

      // Actualizamos las listas que se muestran
      this.model.filterFrameWorkAgreementContractList = auxFrameworkAgreementContractList;
      if (this.model.filterFrameWorkAgreementContractList.length > 0) {
        this.model.filterFrameWorkAgreementContractList.forEach(element => {
          element.newBasedContractEnabled = this.newBasedContractEnabled;
        });
      }
      this.model.filterBasedContractList = auxBasedContractList;
    }
  }



  addLink(items: MenuItem[], identifier: string, description: string, icon: string, componentName: string) {
    let mn: MenuItem = {};
    this.subscribe(
      this.translateService.get(description), ((res: string) => {
        mn.label = res;
      }));
    mn.icon = icon;
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: componentName };
    items.push(mn);

  }

  public getDossierMenuItemAM(identifier: any): MenuItem[] {
    identifier = deNormalizaDossierId(identifier);
    let items: MenuItem[] = [];
    this.addLink(items, identifier, 'DossierInfo.sections.GENERAL_INFO.short', 'fa fa-info-circle', 'GENERAL_INFO');
    this.addLink(items, identifier, 'DossierInfo.sections.DOSSIER_ACTIONS.short', 'fa fa-tasks', 'DOSSIER_ACTIONS');
    this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTSAYMAD');
    this.addLink(items, identifier, 'DossierInfo.sections.DOCUMENTS.short', 'fa fa-file-alt', 'DOCUMENTS');
    this.addLink(items, identifier, 'DossierInfo.sections.ACCOUNTING.short', 'fa fa-euro-sign', 'ACCOUNTING');
    this.addLink(items, identifier, 'DossierInfo.sections.PROCEDURES.short', 'fa fa-list-ul', 'PROCEDURES');
    this.addLink(items, identifier, 'DossierInfo.sections.AUDIT.short', 'fa fa-lg fa-list-ul', 'AUDIT');


    return items;
  }

  public getDossierMenuItemCBAM(identifier: any): MenuItem[] {
    identifier = deNormalizaDossierId(identifier);
    let items: MenuItem[] = [];
    this.addLink(items, identifier, 'DossierInfo.sections.GENERAL_INFO.short', 'fa fa-info-circle', 'GENERAL_INFO');
    this.addLink(items, identifier, 'DossierInfo.sections.DOSSIER_ACTIONS.short', 'fa fa-tasks', 'DOSSIER_ACTIONS');
    this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTSAYMAD');
    this.addLink(items, identifier, 'DossierInfo.sections.DOCUMENTS.short', 'fa fa-file-alt', 'DOCUMENTS');
    this.addLink(items, identifier, 'DossierInfo.sections.ACCOUNTING.short', 'fa fa-euro-sign', 'ACCOUNTING');
    this.addLink(items, identifier, 'DossierInfo.sections.PROCEDURES.short', 'fa fa-list-ul', 'PROCEDURES');
    this.addLink(items, identifier, 'DossierInfo.sections.AUDIT.short', 'fa fa-lg fa-list-ul', 'AUDIT');


    return items;
  }

  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  public getTextAward(model: any) {
    let desc = '';
    if (model.award && model.award.company) {
      desc = model?.award?.company?.taxIdentifier + ' - ' + model?.award?.company?.commercialName
    }
    return desc;
  }


  deNormalizaDossierId(dossierId: string) {
    return deNormalizaDossierId(dossierId);
  }

  openDossier(dossier) {
    let dossierAux = '';
    if (dossier !== undefined && dossier !== '') {
      dossierAux = deNormalizaDossierId(dossier);
    } else {
      dossierAux = this.frameworkAgreementIdentifier;
    }
    this.router.navigate(['/dossierInfo/' + dossierAux]);
  }


}
